import {
  EyeIcon,
  LockClosedIcon,
  LockOpenIcon,
  TrashIcon,
} from "@heroicons/react/24/outline";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import ConfirmDeleteModal from "../../component/sharedComponents/ConfirmDeleteModal";
import Pagination from "../../component/sharedComponents/Pagination";
import { blockUser, deleteUser, getAllUsers } from "../../slices/3-Users/thunk";
import UserDetailsModal from "../../component/SettingsUserPage/UserDetailsModal";
import { setFilter } from "../../slices/searchSlice";
import SectionLoader from "../../component/sharedComponents/Loading/SectionLoader";

const SettingsUserPage = () => {
  const { t } = useTranslation();
  const { users, pagination, loading } = useSelector((state) => state.users)
  const { query, filter } = useSelector((state) => state.search);

  const dispatch = useDispatch()
  const [selectedUser, setSelectedUser] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [deleteUsers, setDeleteUsers] = useState(null);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  useEffect(() => {
    dispatch(getAllUsers({ limit: 10, page: 1 }))
  }, [dispatch])


  useEffect(() => {
    dispatch(
      getAllUsers({
        page: 1,
        limit: 10,
        search: query,
        role: filter,
      })
    );
  }, [query, filter, dispatch]);

  const openDeleteModal = (post) => {
    setDeleteUsers(post);
    setIsDeleteModalOpen(true);
  };

  const closeDeleteModal = () => {
    setDeleteUsers(null);
    setIsDeleteModalOpen(false);
  };

  const confirmDelete = (postId) => {
    dispatch(deleteUser(postId));
    closeDeleteModal();
  };
  const openModal = (post) => {
    setSelectedUser(post);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setSelectedUser(null);
    setIsModalOpen(false);
  };



  const handleToggle = (postId) => {
    // dispatch(togglePostActive(postId));
  }


  const handlePageChange = (page) => {
    dispatch(getAllUsers({
      page: page,
      limit: 10,
      search: query,
      role: filter,
    }));
  };
  return (
    <div className="w-full space-y-4 text-gray-900 dark:text-gray-100">
      {/* Header */}
      <div className="flex flex-wrap items-center justify-between gap-3">
        <h1 className="text-xl font-semibold text-black dark:text-white">
          {t("users.title")}
        </h1>
        <select
          onChange={(e) => dispatch(setFilter(e.target.value))}
          className="px-4 py-2 text-sm border rounded-lg dark:text-text-muted-dark text-text-muted-light dark:bg-bg-dark-secondary bg-bg-light-secondary dark:border-border-dark border-border-light focus:outline-none">
          <option value="">{t("membership.all")}</option>
          <option value="user">{t("membership.user")}</option>
          <option value="owner">{t("membership.owner")}</option>
        </select>
      </div>

      {/* ===== Table Wrapper ===== */}
      <div className="relative overflow-x-auto no-scrollbar w-[90vw] md:w-full   ">
        {/* IMPORTANT: min-width */}
        <div className="w-full ">

          {loading ? <SectionLoader /> : users?.length === 0 ? <p className="w-full text-center">{t("NotFound")}</p> :
            <>
              <div className="w-full overflow-x-auto">

                <table className="w-full text-sm text-left border rounded-xl dark:border-border-dark border-border-light ">
                  <thead className="text-xs uppercase dark:bg-bg-dark-secondary bg-bg-light-secondary">
                    <tr className="text-center">
                      <th className="px-4 py-3">{t("users.ID")}</th>
                      <th className="px-4 py-3">{t("users.fullName")}</th>
                      <th className="px-4 py-3">{t("users.phone")}</th>
                      <th className="px-4 py-3">{t("users.email")}</th>
                      <th className="px-4 py-3">{t("users.date")}</th>
                      <th className="px-4 py-3">{t("users.state")}</th>
                      <th className="px-4 py-3">{t("users.membership")}</th>
                      <th className="px-4 py-3 text-center">
                        {t("users.actions")}
                      </th>
                    </tr>
                  </thead>
                  <tbody className="py-2 dark:bg-bg-dark-secondary bg-bg-light-secondary">
                    {
                      users?.map((user, index) => (
                        <>
                          <tr>
                            <td colSpan={8} className="px-4 ">
                              <div className="mx-4 border-t dark:border-border-dark border-border-light"></div>
                            </td>
                          </tr>
                          <tr
                            key={user?.id}
                            className="text-center duration-300 hover:bg-bg-light-primary dark:hover:bg-bg-dark-primary "
                          >
                            <td className="px-2 py-3">{index + 1}</td>

                            <td className="px-2">{user?.fullName}</td>
                            <td className="px-2">{user?.phone}</td>
                            <td className="px-2">{user?.email}</td>
                            <td className="px-2">{new Date(user?.createdAt).toLocaleDateString()}</td>
                            <td className="px-2">
                              <span className="px-3 py-1 text-xs dark:text-primary text-primary-light  bg-[#00FFEA1A] rounded-xl">
                                {user?.confirmEmail ? <>{t("confirmEmail.confirmed")}</> : <>{t("confirmEmail.unconfirmed")}</>}
                              </span>

                            </td>
                            <td className="px-2">
                              {user?.role === "user" ? (
                                <span className="px-3 py-1 text-xs dark:text-[#00FFEA] text-[#003531] bg-[#00e3d01a] dark:bg-[#00FFEA1A] rounded-xl">
                                  {t(`role.${user?.role}`)}
                                </span>
                              ) : (
                                <span className="px-3 py-1 text-xs text-red-500 dark:bg-[#BBFF001A] bg-[#abea00] rounded-xl">
                                  {t(`role.${user?.role}`)}
                                </span>
                              )}
                            </td>
                            <td className="px-2">
                              <div className="flex items-center justify-center gap-3">
                                <button
                                  onClick={() => openModal(user)}
                                  title={t("viewUser")}
                                >
                                  <EyeIcon className="w-5 h-5 text-yellow-400" />
                                </button>

                                <button
                                  onClick={() =>
                                    dispatch(
                                      blockUser({
                                        id: user?.id,
                                      })
                                    )
                                  }
                                  title={user?.isBlocked ? t("unblockUser") : t("blockUser")}
                                  className="p-2 transition-colors duration-300 rounded-lg hover:bg-bg-light-tertiary dark:hover:bg-bg-dark-tertiary"
                                >
                                  {!user?.isBlocked ? (
                                    <LockOpenIcon className="w-5 h-5 text-green-500" />
                                  ) : (
                                    <LockClosedIcon className="w-5 h-5 text-red-500" />
                                  )}
                                </button>

                                <button
                                  onClick={() => openDeleteModal(user)}
                                  title={t("deleteUser")}
                                >
                                  <TrashIcon className="w-5 h-5 text-red-500" />
                                </button>
                              </div>
                            </td>
                          </tr>
                        </>
                      ))
                    }
                  </tbody>
                </table>
              </div>

              {pagination && users?.length > 0 && (
                <Pagination
                  pagination={pagination}
                  onPageChange={(page) => handlePageChange(page)}
                />
              )}
            </>
          }
        </div>
        {selectedUser && (
          <UserDetailsModal isOpen={isModalOpen} onClose={closeModal} user={selectedUser} />
        )}
        {deleteUsers && (
          <ConfirmDeleteModal
            isOpen={isDeleteModalOpen}
            onClose={closeDeleteModal}
            onConfirm={confirmDelete}
            post={deleteUsers}
          />
        )}
      </div>
    </div>
  );
};

export default SettingsUserPage;
